import { FC } from "react";
import { AppPartType } from "../../../types";
import { Radio } from "antd";

type Prop = {
  appPart: AppPartType;
};
const RadioButton: FC<Prop> = ({
  appPart: { default_value, item_config_data },
}) => {
  const listOptions =
    Array.isArray(item_config_data?.options) &&
    item_config_data?.options?.length > 0
      ? item_config_data?.options
      : [
          { text: "サンプル1", value: "サンプル1" },
          { text: "サンプル2", value: "サンプル2" },
        ];
  return (
    <div
      className={`options-container ${
        item_config_data.layout === "vertical" ? "" : "is-horizontal"
      }`}
    >
      {listOptions.map((option, index) => (
        <label key={`${option.text}_${index}`} className="option">
          <Radio checked={option.text === default_value}></Radio>
          <span className="option-label">{option.text}</span>
        </label>
      ))}
    </div>
  );
};

export default RadioButton;
